// extracted by mini-css-extract-plugin
export var backFlip = "fixedMobileMenu-module--backFlip--b4b8d";
export var button = "fixedMobileMenu-module--button--a6709";
export var flip = "fixedMobileMenu-module--flip--f3f68";
export var wrapper = "fixedMobileMenu-module--wrapper--06c6d";